import React from "react";

// import './Footer.css';

import { useSelector } from "react-redux";

import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";

import { useNavigate } from "react-router-dom";
import { website_url } from "../bootapi";

function FooterSeventhJournal({
  footeremail,
  footernum,
  toggleMenu,
  togglefeedback,
}) {
  const darkMode = useSelector((state) => state.theme.darkMode);
  const openlink = (link) => {
    window.open(link, "_blank");
  };
  return (
    <div
      className="landing-page-two-wrapper"
      onClick={() => {
        toggleMenu();
      }}
    >
      <section
        className={`${
          darkMode
            ? "landing-page-section-footer-dark "
            : "landing-page-section-footer"
        } `}
      >
        <div className="container ">
          <div className="row journal-row ">
            <div className="flexColStart w-100 rg-1 journal-footer-row-container">
              <div className="flexRowStart w-100 jc-spb journal-footer-top-container">
                <div className=" company-column flexColStart rg-1  ">
                  <img
                    src={
                      darkMode
                        ? "https://db.seventhsight.com/storage/v1/object/public/Website_Images/SeventhSightLogoDark.png"
                        : "https://db.seventhsight.com/storage/v1/object/public/Website_Images/SeventhArcMainLogo.png"
                    }
                    alt="logo"
                    className="seventh-sight-logo "
                  />
                  <p className="">
                    Powerful Dream Analysis Created to Translate your
                    Subconscious to your Conscious Mind and Awaken Your
                    Potential.
                  </p>
                </div>
                <div className="flexColStart rg-1 ">
                  <p className="underline-text">Quick Links</p>
                  <div className=" links ">
                    <div className="about-us">
                      <span>About us</span>
                      <span>Resources</span>
                      <a href="/faq">FAQs/Videos</a>
                    </div>
                    <div className="your-account">
                      <a href="/auth/additionalDetails">Your Account</a>
                      <a href={`${website_url}/blog/`} target="_blank">
                        Dream Blog
                      </a>
                      <a href="/contactus">Contact Us</a>
                    </div>
                  </div>
                </div>
                <div className="flexColStart rg-1  ">
                  <p className="underline-text">Contact Us</p>
                  <div className=" links ">
                    <div className="contact-us about-us ">
                      <div className="info">
                        <LocalPhoneOutlinedIcon className="prmiary-color" />
                        <a href={`tel:+${footernum}`}>{footernum}</a>
                      </div>
                      <div className="info">
                        <MailOutlineOutlinedIcon className="prmiary-color" />
                        <a href={`mailto:${footeremail}`}>{footeremail}</a>
                      </div>
                      <div className="flexRowStart w-100 cg-1">
                        <img
                          className="icon-48 pointer"
                          src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/facebook.png?t=2024-01-09T18%3A11%3A44.244Z"
                          alt="icon"
                          onClick={() =>
                            openlink("https://www.facebook.com/SeventhSightAi/")
                          }
                        />
                        <img
                          className="icon-48 pointer"
                          src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/twitter.png?t=2024-01-10T08%3A26%3A05.484Z"
                          alt="icon"
                          onClick={() =>
                            openlink("https://www.Twitter.com/seventhsightai/")
                          }
                        />
                        <img
                          className="icon-48 pointer"
                          src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/instagram.png?t=2024-01-10T06%3A26%3A52.342Z"
                          alt="icon"
                          onClick={() =>
                            openlink(
                              "https://www.instagram.com/seventhsightai/"
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flexRowStart w-100 jc-spb journal-footer-copyright-container">
                <p>&copy;SeventhSIGHT - All Rights Reserved</p>
                <div className="cg-1 info flexRowStart">
                  <a href="/data-subject">Data Subject Access Request</a>
                  <a href="/terms-conditions">Terms & Conditions</a>
                  <a href="/privacy-policy">Privacy Policy</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FooterSeventhJournal;
